import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoyaltyCardAlV1Component } from './loyalty-card-al-v1/loyalty-card-al-v1.component';
import { LoyaltyCardActionButtonsComponent } from './loyalty-card-al-v1/loyalty-card-action-buttons/loyalty-card-action-buttons.component';



@NgModule({
  declarations: [
    LoyaltyCardAlV1Component,
    LoyaltyCardActionButtonsComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    LoyaltyCardAlV1Component
  ],
  providers: [
    LoyaltyCardAlV1Component
  ]
})
export class LoyaltyCardModule { }
